import { ListGroup } from "react-bootstrap";
import CartItem from "./CartItem";

const CartList = ({ cartItems, onRemove, onUpdateQuantity, onSelectItem }) => {

    return (
        <ListGroup variant="flush">
            {/* <ListGroup.Item className="fw-bold py-2"> */}
                <div className="d-flex pt-2 p-2">
                    <span className="col-3 fw-bold p-2">Paket</span>
                    <span className="col-9 fw-bold p-2">Harga</span>
                </div>
            {/* </ListGroup.Item> */}
            {(cartItems).map((item) => (
                <CartItem
                    key={item?.id}
                    item={item}
                    onRemove={onRemove}
                    onUpdateQuantity={onUpdateQuantity}
                    onSelectItem={onSelectItem}
                />
            ))}
        </ListGroup>
    );
};

export default CartList